import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import backend from "i18next-http-backend";
import detector from "i18next-browser-languagedetector";

import enPage from "../locales/en_US/page.json";
import myPage from "../locales/ms_MY/page.json";

import enForm from "../locales/en_US/form.json";
import myForm from "../locales/ms_MY/form.json";

const resources = {
  en: { translation: { ...enPage, ...enForm } },
  my: { translation: { ...myPage, ...myForm } },
};

i18next
  /**
   * Load translation from /public/locales using HTTP back-end.
   * @see Docs {@link https://www.i18next.com/overview/plugins-and-utils#backends}
   * @see Example {@link https://github.com/i18next/react-i18next/tree/master/example/react/public/locales}
   * @see Source {@link https://github.com/i18next/i18next-http-backend}
   */
  .use(backend)
  /**
   * Detect user language.
   * @see Source {@link https://github.com/i18next/i18next-browser-languageDetector}
   */
  .use(detector)
  /**
   * Pass i18n instance to react-i18next.
   */
  .use(initReactI18next)
  /**
   * Initialize i18next configuration.
   * @see Docs {@link https://react.i18next.com/latest/i18next-instance}
   * @see Options {@link https://www.i18next.com/overview/configuration-options}
   */
  .init({
    lng: 'en',
    fallbackLng: "en",
    debug: false,
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    resources,
  });

export default i18next;